<template>
    <div  id="importRaces">
        <v-stepper v-model="step">
            <v-stepper-header>
                <v-stepper-step
                    :complete="step > 1"
                    step="1"
                ></v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step
                    :complete="step > 2"
                    step="2"
                ></v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step :complete="step > 3" step="3"></v-stepper-step>
                <v-divider></v-divider>

                <v-stepper-step step="4" ></v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
                <v-stepper-content step="1">
                    <v-row>
                        <v-col cols="12" md="10" class="mx-auto">
                            <v-row>
                                <v-col cols="12" class="text-left">
                                    <h3>{{$t("page.importRaces.step1.title")}}</h3>
                                </v-col>
                            </v-row> 
                            <v-row>
                                <v-col cols="12">
                                    <WarningBox class="fitcontent">
                                        <h3 class="text-left mt-0 ml-4">{{$t("page.importRaces.step1.warning")}}</h3>
                                        <p class="text-left ml-4">{{$t("page.importRaces.step1.description_warning")}}</p>
                                    </WarningBox>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <VueTabulator ref="tabulator" v-model="tabulatorData" :options="tabulatorOptions" />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <div class="space"> </div>
                </v-stepper-content>

                <v-stepper-content step="2">
                    <v-row>
                        <v-col cols="12" md="10" class="mx-auto">
                            <v-row>
                                <v-col cols="6">
                                    <v-btn color="primary" class="float-left btn-small" @click="back">{{$t("common.back")}}</v-btn>
                                </v-col>
                                <v-col cols="6">
                                    <v-btn color="primary" class="float-right btn-small" @click="next">{{$t("common.next")}}</v-btn>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="text-left">
                                    <h3>{{$t("page.importRaces.step2.title", { eventName })}}</h3>
                                </v-col>
                            </v-row> 
                            <v-form ref="formTesting" lazy-validation>
                                <v-row>
                                    <v-col cols="12" md="6" sm="9">
                                        <v-select
                                            :items="typeItems"
                                            v-model="typeSelected"
                                            :label="$t('page.importRaces.race_type')"
                                            :rules="typeRules"
                                            item-text="mode"
                                            item-value="id"
                                            dense
                                            outlined
                                        ></v-select>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="6" sm="9">
                                        <v-text-field 
                                            outlined dense 
                                            :label="$t('page.importRaces.race_name')" 
                                            v-model="raceName"
                                            :rules="nameRules"
                                            lazy-rules
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-col>
                    </v-row>
                </v-stepper-content>

                <v-stepper-content step="3">
                    <v-row>
                        <v-col cols="12" class="mx-auto">
                            <v-row>
                                <v-col xl="1" lg="1" md="2" sm="2" cols="6">
                                    <v-btn color="primary" class="float-left btn-small" @click="back" :title="$t('common.back')">{{$t("common.back")}}</v-btn>
                                </v-col>
                                <v-col xl="10" lg="10" md="8" sm="8" class="d-none d-sm-flex">
                                    <WarningBox class="fitcontent">
                                        <h3 class="text-left mt-0 ml-4">{{$t("page.importRaces.step3.importing_file")}}</h3>
                                        <p class="text-left ml-4">
                                            {{$t("page.importRaces.step3.description_1")}}.</p>
                                        <p v-if="!isMototallyImport" class="text-left ml-4">{{$t("page.importRaces.step3.description_2")}} 
                                            <a href="/Documents/TemplateRaceImport.csv">TemplateRaceImport.csv</a>
                                        </p>
                                        <p v-else class="text-left ml-4 import-race-description">{{$t("page.importRaces.step3.description_3")}}</p>
                                    </WarningBox>
                                </v-col>
                                <v-col xl="1" lg="1" md="2" sm="2" cols="6">
                                    <v-btn
                                        color="primary"
                                        class="float-right btn-small"
                                        @click="importRace"
                                        :disabled="importingRace"
                                        :title="$t('common.import')"
                                    >
                                        {{$t("common.import")}}
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="d-flex d-sm-none">
                                    <WarningBox class="fitcontent">
                                        <h3 class="text-left mt-0 ml-4">{{$t("page.importRaces.step3.importing_file")}}</h3>
                                        <p class="text-left ml-4">
                                            {{$t("page.importRaces.step3.description_1")}} </p>                                            
                                        <p v-if="!isMototallyImport" class="text-left ml-4">
                                            {{$t("page.importRaces.step3.description_2")}} <a href="/Documents/TemplateRaceImport.csv">TemplateRaceImport.csv</a>
                                        </p>
                                        <p v-else class="text-left ml-4 import-race-description">{{$t("page.importRaces.step3.description_3")}}</p>
                                    </WarningBox>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="text-left">
                                    <h3>{{$t("page.importRaces.step3.subtitle", { raceName })}}</h3>
                                </v-col>
                                <v-col cols="12" class="d-flex">
                                    <v-btn color="primary" class="float-left mx-auto" style="min-width: 200px;" @click="openFile">{{$t("page.importRaces.step3.btn_text")}}</v-btn>
                                </v-col>
                                <v-col cols="12" class="d-flex">
                                    <div v-if="fileName" class="mx-auto" style="min-width: 200px;">
                                        <span class="float-left ml-2">{{fileName}}</span>
                                        <v-icon class="float-right mr-2" @click="deleteFile">fa-trash</v-icon>
                                    </div>
                                    <input
                                        type="file"
                                        id="fileInput"
                                        accept=".csv"
                                        label="File input"
                                        class="d-none"
                                        @change="onFileChange($event)"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-stepper-content>

                <v-stepper-content step="4">
                    <v-row>
                        <v-col cols="12">
                            <h3 class="mb-2" style="text-align: center;">{{$t("page.importRaces.step4.message")}}</h3>
                            <div class="d-flex justify-content-center" style="justify-content: center;">
                                <v-btn color="primary" style="width: 200px;" class="mr-2" @click="raceDetail">{{$t("page.importRaces.step4.btn")}}</v-btn>
                                <v-btn color="primary" style="width: 200px;" @click="importAnotherRace">{{$t("page.importRaces.step4.btn_import_another_race")}}</v-btn>
                            </div>
                        </v-col>
                    </v-row>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
        <SGSNotificationAlert 
            :snackbar="alert" :notificationMessage="msgAlert" @cancel="closeAlert" 
            :type="typeAlert" :right="true" :top="true" class="alert"
        />
        <v-overlay :value="importingRace">
            <v-card light class="race-import-progress pa-6">
                <h3 class="mb-4">{{$t("page.importRaces.progress.title")}}</h3>
                <v-progress-linear
                    color="primary"
                    height="12"
                    indeterminate
                    rounded
                ></v-progress-linear>
                <p class="mb-0 mt-4">{{importStatusMessage}}</p>
            </v-card>
        </v-overlay>
    </div>
</template>

<script>
import WarningBox from '@/components/custom/notification/WarningBox.vue';
import moment from "moment";
import { apiCalls } from "@/mixins/apiCalls.js";
import { VBtn } from 'vuetify/lib';
import Vue from 'vue';
import SGSNotificationAlert from "@/components/custom/notification/Alert.vue";
import axios from "axios";

const dateEditor = function(cell, onRendered, success, cancel){
    //cell - the cell component for the editable cell
    //onRendered - function to call when the editor has been rendered
    //success - function to call to pass thesuccessfully updated value to Tabulator
    //cancel - function to call to abort the edit and return to a normal cell

    //create and style input
    var valueCell = cell.getValue(),
    cellValue = valueCell ? moment(cell.getValue(), "DD/MM/YYYY").tz('America/New_York', true).format("YYYY-MM-DD") : undefined,
    input = document.createElement("input");

    input.setAttribute("type", "date");

    input.style.padding = "4px";
    input.style.width = "100%";
    input.style.boxSizing = "border-box";
    input.setAttribute("placeholder", "yyyy-mm-dd");
    
    input.value = cellValue;

    onRendered(function(){
        input.focus();
        input.style.height = "100%";
    });

    function onChange(){
        if(input.value != cellValue){
            if(input.value && input.value != '') {
                const newValue = moment(input.value, "YYYY-MM-DD").tz('America/New_York', true).format("YYYY-MM-DD");
                if(newValue) success(newValue); else success('');
            } else {
                success('');
            }
        }else{
            cancel();
        }
    }

    //submit new value on blur or change
    input.addEventListener("change", onChange);
    input.addEventListener("blur", onChange);

    //submit new value on enter
    input.addEventListener("keydown", function(e){
        if(e.keyCode == 13){
            onChange();
        }

        if(e.keyCode == 27){
            cancel();
        }
    });

    return input;
};

export default {
    mixins: [apiCalls],
    components: { WarningBox, SGSNotificationAlert },
    data() {
        const parent = this;
        const btnSelect = function(cell){
            const valueData = cell.getData();
            const buttonClass = Vue.extend(VBtn);
            const buttonInstance = new buttonClass();
            buttonInstance.$mount();
            buttonInstance.$el.classList.add("primary");
            buttonInstance.$el.classList.add("btnTabulatorSelect");
            buttonInstance.$el.classList.add("my-2");
            const elements = buttonInstance.$el.getElementsByClassName("v-btn__content");
            if(elements) {
                elements[0].innerText = "Select";
            }
            buttonInstance.$on("click", function() {
                parent.selectEvent(valueData);
            });
            return buttonInstance.$el;
        };
        return {
            importingRace: false,
            importStatusMessage: "",
            step:1, 
            tabulatorData: [],
            tabulatorOptions: {
                layout: "fitColumns",
                placeholder: "No Data Set",
                height: 350,
                printAsHtml: true,
                downloadRowRange: "all",
                layoutColumnsOnNewData: true,
                initialSort: [{column:"eventDate", dir:"desc"}],
                columns: [
                    {
                        title: this.$t("page.importEvent.id"),
                        field: "eid",
                        sorter: "string",
                        headerFilter: "input",
                        headerFilterPlaceholder: " ",
                        minWidth: 50,
                        width: 60,
                        formatter: "textarea"
                    },
                    {
                        title: this.$t("page.importEvent.promoter"),
                        field: "promoter",
                        sorter: "string",
                        headerFilter: "input",
                        headerFilterPlaceholder: " ",
                        minWidth: 100,
                        formatter: "textarea"
                    },
                    {
                        title: this.$t("page.importEvent.event"),
                        field: "event",
                        sorter: "string",
                        headerFilter: "input",
                        headerFilterPlaceholder: " ",
                        minWidth: 100,
                        formatter: "textarea"
                    },
                    {
                        title: this.$t("page.importEvent.event_date"),
                        field: "eventDate",
                        sorter: "string",
                        headerFilter: dateEditor,
                        headerFilterPlaceholder: " ",
                        minWidth: 160,
                        width: 160,
                        formatter: "textarea"
                    },
                    {
                        title: this.$t("page.importRaces.action"),
                        field: "action",
                        minWidth: 110,
                        width: 150,
                        hozAlign: "center",
                        vertAlign: "center",
                        headerSort: false,
                        formatter: btnSelect,
                        cellClick: function (e, cell) {
                            const data = cell.getData();
                            this.eventSelected = data;
                            this.showNot = true;
                            this.oom = false;
                        }.bind(this)
                    }
                ]
            },
            eventSelected: null,
            typeSelected: null,
            raceModes: null,
            raceName: "",
            valid: true,
            alert: false,
            msgAlert: '',
            typeAlert: 'warning',
            fileName: null,
            uploadFile_: null,
            newRaceId: null,
        };
    },
    computed: {
        eventName() {
            if(this.eventSelected) return this.eventSelected.event;
            return "";
        },
        typeRules() {
            return [
                v => {
                    return !!v || this.$tc('page.importRaces.type_required')
                }
            ];
        },
        nameRules() {
            return [
                v => {
                    return (v || "").length > 0 || this.$tc('page.importRaces.name_required')
                }
            ];
        },
        typeItems(){
            return [
                { id: 'from-template', mode: this.$t('page.importRaces.from_template') },
                { id: 'mototally-import', mode: this.$t('page.importRaces.mototally-import') },

            ]
        },
        isMototallyImport(){
            return this.typeSelected === 'mototally-import' ? true : false;
        }
    },
    watch: {
        typeItems: {
            immediate: true,
            handler(newItems) {
                if (this.typeSelected === null && newItems && newItems.length > 0) {
                    this.typeSelected = newItems[0].id;
                }
            }
        }
    },
    methods: {
        importAnotherRace(){
            this.step = 1;
            this.raceName = "";
            this.deleteFile();
            this.$nextTick(() => {
                this.$refs.formTesting.resetValidation();
            });
        },
        raceDetail(){
            //this.$router.push({ name: 'raceDetails', params: {id: this.newRaceId}});ref:
            window.location.href = `${process.env.VUE_APP_ROOT}/admin/raceDetails?raceId=${this.newRaceId}`;
        },
        async getEvents(eventId = -1) {
            const response = await this.getApi(`/api/v1/promoter/importEvent/getEvents`);
            
            if(response.success) {
                this.tabulatorData = response.message;
                if(eventId > 0) {
                    this.eventSelected = this.tabulatorData.find(event => {
                        return event.eid == eventId;
                    });
                }
            }
        },
        async getRacesType() {
            const response = await this.getApi(`/api/v1/promoter/importRace/getRacesType`);
            
            if(response.success) {
                this.raceModes = response.message;
            }
        },
        selectEvent(item) {
            this.eventSelected = item;
            this.step++;
            this.getRacesType();
        },
        back() {
            if(this.step > 0) this.step--;
        },
        next() {
            if(!this.$refs.formTesting.validate()) {
                this.showAlert(this.$t('page.importRaces.empty_form'), 'error');
                return;
            }
            this.step++;
        },
        closeAlert() {
            this.alert = false;
            const parent = this;
            setTimeout(function() {
                parent.msgAlert = '';
                parent.typeAlert = 'warning';
            },1000);
        },
        showAlert(msg, type) {
            this.alert = true;
            this.msgAlert = msg;
            this.typeAlert = type;
        },
        translateImportRaceMessage(message) {
            if (Array.isArray(message)) {
                return message.map(msg => this.translateImportRaceMessage(msg));
            }

            if (!message) {
                return this.$t("page.importRaces.import_failed");
            }

            const key = `page.importRaces.${message}`;
            return this.$te(key) ? this.$t(key) : message;
        },
        showImportRaceErrors(message) {
            const messages = this.translateImportRaceMessage(message);
            const alertMessage = Array.isArray(messages) ? messages.join(" ") : messages;

            this.showAlert(alertMessage, "error");
        },
        openFile() {
            document.getElementById("fileInput").click();
        },
        onFileChange(e) {
            this.uploadFile_ = e.target.files[0];
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.fileName = files[0].name;
        },
        deleteFile() {
            this.uploadFile_ = null;
            this.fileName = null;
            const fileInput = document.getElementById("fileInput");
            if (fileInput) fileInput.value = "";
        },
        async importRace() {
            if (!this.uploadFile_) {
                this.showAlert(this.$t("page.importRaces.not_file_import"), "error");
                return;
            }

            this.importingRace = true;
            this.importStatusMessage = this.$t("page.importRaces.progress.processing");

            try {
                const createResponse = await this.postApi(
                    `/api/v1/promoter/importRace/${this.eventSelected.eid}`,
                    { raceName: this.raceName, mode: 10 }
                );
                const createData = createResponse.data || createResponse;
                if (!createData.success) {
                    throw createData.message;
                }

                const newRaceId = createData.message;
                const formData = new FormData();
                formData.append("newRaceId", newRaceId);
                formData.append("file", this.uploadFile_);
                const urlApi = this.isMototallyImport
                    ? `/api/v1/promoter/importMototally/${this.eventSelected.eid}/upload`
                    : `/api/v1/promoter/importRace/${this.eventSelected.eid}/upload`;
                const responseImport = await axios.post(
                    `${this.root}/laravel/public${urlApi}`,
                    formData
                );
                const responseImportData = responseImport.data || responseImport;
                if (!responseImportData.success) {
                    throw responseImportData.message;
                }

                const importResult = responseImportData.message || {};
                this.showAlert(
                    this.$t("page.importRaces.rider_resolution.import_summary", {
                        matched: importResult.matchedUsers || 0,
                        created: importResult.createdUsers || 0,
                    }),
                    "success"
                );
                this.newRaceId = newRaceId;
                this.step++;
            } catch (error) {
                this.showImportRaceErrors(error.message || error);
            } finally {
                this.importingRace = false;
            }
        }
    },
    mounted() {
        /*const eventId = localStorage.getItem('eventIdRaceImport');
        if(eventId) {
            this.selectEvent({ eid: eventId });
        }*/
        this.getEvents();
    },
    beforeDestroy() {
        localStorage.removeItem('eventIdRaceImport');
    }
}
</script>

<style lang="scss">
#importRaces {
    .race-import-progress {
        width: 420px;
        max-width: calc(100vw - 32px);
        text-align: center;
    }
    .tabulator[tabulator-layout=fitColumns] .tabulator-row .tabulator-cell:last-of-type {
        background-color: transparent !important;
    }
    .import-race-description {
        overflow-wrap: break-word;
        white-space: pre-line;
    }
    @media screen and (max-width: 959px) {
        .btn-small {
            max-width: 100%;
            font-size: 11px;
            .v-btn__content {
                white-space: pre;
                width: 100%;
                display: block;
            }
        }
    }
}
</style>
<style>
#contentMain {
    overflow-x: initial !important;
    /*overflow-y: hidden !important;*/
}
.space{
    height: 200px;
}
div.v-alert.fitcontent {
    width: fit-content !important;
}
</style>
